import { formatPct } from "../formatters"
import { IAnalysisValueColumn } from "../types"

export function getSsmColumns(): IAnalysisValueColumn[] {

    return [

        { name: "P2O5", units: "ppm", header: "P<sub>2</sub>O<sub>5</sub>", index: true, visible: true, gauge: true },
        { name: "K2O", units: "ppm", header: "K<sub>2</sub>O", index: true, visible: true, gauge: true },
        { name: "MgO", units: "ppm", index: true, visible: true, gauge: true },
        { name: "WaterpH", units: "", header: "pH", key: "pH", visible: true, gauge: true },
        { name: "BufferPh", units: "", header: "Buffer pH", key: "pH", visible: false, gauge: true },

        { name: "Sand", units: "%", header: "Sand", key: "Sand" },
        { name: "Silt", units: "%", header: "Silt", key: "Silt" },
        { name: "Clay", units: "%", header: "Clay", key: "Clay" },
        { name: "SoilCEC", units: "meq/100g", header: "Soil CEC", key: "SoilCEC" },
        { name: "OrganicMatterLoi", units: "%", header: "Organic Matter (Loi)", key: "OrganicMatter", visible: true },
        { name: "ActiveCarbon", units: "%", header: "Active Carbon" },
        { name: "CO2Burst", units: "mg/kg", header: "CO<sup>2</sup> burst" },

        { name: "TotalCaO", units: "kg/ha", header: "Total CaO" },
        { name: "TotalMgO", units: "kg/ha", header: "Total MgO" },
        { name: "TotalK2O", units: "kg/ha", header: "Total K<sub>2</sub>O" },
        { name: "TotalNa", units: "kg/ha", header: "Total Na" },
        { name: "TotalSO3", units: "kg/ha", header: "Total SO<sub>3</sub>" },
        { name: "TotalP2O5", units: "kg/ha", header: "Total P<sub>2</sub>O<sub>5</sub>" },

        { name: "AvailableCaO", units: "kg/ha", header: "Available CaO" },
        { name: "AvailableMgO", units: "kg/ha", header: "Available MgO" },
        { name: "AvailableK2O", units: "kg/ha", header: "Available K<sub>2</sub>O" },
        { name: "AvailableNa", units: "kg/ha", header: "Available Na" },
        { name: "AvailableSO3", units: "kg/ha", header: "Available SO<sub>3</sub>" },
        { name: "AvailableP2O5", units: "kg/ha", header: "Available P<sub>2</sub>O<sub>5</sub>" },

        { name: "Boron", units: "mg/l", header: "Boron", key: "Boron" },
        { name: "Iron", units: "mg/l", header: "Iron", key: "Iron" },
        { name: "Manganese", units: "mg/l", header: "Manganese", key: "Manganese" },
        { name: "Copper", units: "mg/l", header: "Copper", key: "Copper" },
        { name: "Zinc", units: "mg/l", header: "Zinc", key: "Zinc" },
        { name: "Chlorine", units: "mg/l", header: "Chlorine", key: "Chlorine" },
        { name: "Cobalt", units: "mg/l", header: "Cobalt", key: "Chlorine" },
        { name: "Molybdenum", units: "mg/l", header: "Molybdenum", key: "Molybdenum" },

    ]

}
